import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gradient-to-tr from-[#fdf2f8] via-[#fce7f3] to-[#fce7f9] flex flex-col items-center justify-center text-center px-6">
      {/* noindex obligatoire : le fallback SPA répond 200 sur les URLs
          inexistantes. Sans cette balise, Google indexe la page 404 comme
          une vraie page → erreurs "Soft 404" dans Search Console. */}
      <Helmet>
        <title>Page introuvable | recruteurs.io</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
      </Helmet>
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="max-w-xl"
      >
        <h1 className="text-[120px] leading-none font-black text-transparent bg-clip-text bg-gradient-to-r from-[#d03484] to-[#d47254]">
          404
        </h1>
        <p className="text-xl md:text-2xl font-semibold text-neutral-800 mt-2">
          Oups… Vous êtes sorti du tunnel.
        </p>
        <p className="text-neutral-600 mt-2">
          Cette page n’existe pas (ou plus). On recrute peut-être quelqu’un pour la retrouver.
        </p>

        <Link
          to="/"
          className="inline-block mt-6 px-6 py-3 bg-[#d03484] text-white rounded-xl shadow-md hover:scale-105 transition-transform"
        >
          Revenir à l'accueil
        </Link>
      </motion.div>

      <motion.div
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.5 }}
        className="mt-12"
      >
        <img
          src="https://ygkvhunsrhvgddngoulm.supabase.co/storage/v1/object/public/images/Illustrations/Fond%20png%20pour%20site%20%20(1).png"
          alt="404 illustration"
          className="max-w-xs md:max-w-sm mx-auto"
        />
      </motion.div>
    </div>
  );
}